<template>
	<!-- @TODO Translate all of the hype texts! -->
	<div class="review-section">
		<div :class="['feedback-section-header', {'has-feedback': product.averageRating && ratingReviewCount}]">
			<h2>
				{{ heading }}
				<span class="badge">({{ nrReviews }})</span>
				<review-section-info />
			</h2>
			<review-form
				v-if="isWritingReview || isWritingHype"
				:isWritingReview="isWritingReview"
				:product="product"
			/>
			<template v-else>
				<div
					v-if="product.averageRating && ratingReviewCount != 0"
					class="rating-wrap"
				>
					<span
						v-if="displayStars"
						class="semibold"
					>{{ tr('AVERAGE_SCORE') }}</span>
					<span
						v-else
						class="semibold"
					>Hypefaktor</span>
					<span class="rating">
						<stars
							v-if="displayStars"
							:stars="rating"
							class="stars-lg align-middle"
						/>
						<flames
							v-else
							:flames="rating"
							class="flames-lg align-middle"
						/>
						<span class="count">({{ ratingReviewCount }} st)</span>
					</span>
				</div>
				<text-button
					v-if="productIsReleased"
					:disabled="userHasReviewed !== false"
					:text="tr('CREATE')"
					class="review-section-button"
					@click="writeReview"
				/>
				<text-button
					v-else
					:disabled="userHasHyped !== false"
					text="Hypa produkt"
					class="review-section-button"
					@click="writeHype"
				/>
				<dropdown-select
					v-if="reviews.length || hypes.length"
					v-model="sortingOption"
					:items="sortingOptions"
					:formatter="tr"
					prefix="SORT_BY"
					fullWidth
					class="review-section-dropdown"
				/>
			</template>
		</div>
		<hr v-if="! reviews.length && ! hypes.length">
		<div
			v-if="productIsReleased"
		>
			<h3
				v-if="defaultSorting && upvotedReview"
				class="mb-3"
			>
				Framröstad topprecension
			</h3>
			<review
				v-for="(review, index) in computedReviews"
				:review="review"
				:key="review.id"
				:userVotes="userReviewVotes"
				:displayProductName="displayProductNames"
				:isUpvotedReview="defaultSorting && upvotedReview && index === 0"
			/>
			<p v-if="! reviews.length && ! upvotedReview" class="no-feedback">
				{{ tr('NO_REVIEWS') }}
			</p>
			<!-- Separator -->
			<div v-if="computedHypes.length">
				<hr v-if="! reviews.length && ! upvotedReview">
				<b>Förväntningar innan produktens release</b>
				<hr>
			</div>
			<review
				v-for="hype in computedHypes"
				:review="hype"
				:key="hype.id"
				:isHype="true"
				:userVotes="userReviewVotes"
				:displayProductName="displayProductNames"
			/>
		</div>
		<div v-else class="mt-5">
			<h3
				v-if="defaultSorting && upvotedReview"
				class="mb-3"
			>
				Framröstad hype
			</h3>
			<review
				v-for="(hype, index) in computedHypes"
				:review="hype"
				:key="hype.id"
				:isHype="true"
				:userVotes="userReviewVotes"
				:displayProductName="displayProductNames"
				:isUpvotedReview="defaultSorting && upvotedReview && index === 0"
			/>
			<p v-if="! hypes.length" class="no-feedback">
				Denna produkt har ännu inte blivit hypad!
			</p>
		</div>
		<div ref="moreLessButtons">
			<center
				v-if="reviews.length + hypes.length > 5"
				style="user-select: none"
			>
				<!-- @TODO translate. -->
				<a
					v-if="page === 1"
					@click="incrementPage()"
				>
					Visa fler {{ productIsReleased ? 'recensioner' : 'förväntningar' }}
				</a>
				<a
					v-else-if="! hasMorePages"
					@click="setPage(1)"
				>
					Visa färre {{ productIsReleased ? 'recensioner' : 'förväntningar' }}
				</a>
				<span v-else-if="page > 1">
					<span>
						Visa
					</span>
					<a
						v-if="hasMorePages"
						@click="incrementPage()"
					>fler</a> /
					<a
						v-if="page > 1"
						@click="setPage(1)"
					>färre</a>
					<span>
						{{ productIsReleased ? 'recensioner' : 'förväntningar' }}
					</span>
				</span>
			</center>
		</div>
	</div>
</template>

<script>
import { t } from 'datastore/i18n';
import alert from 'alert';
import store from 'datastore';
import { mapState, mapGetters } from 'vuex';
import { isGroupProduct, getAllVariants, getReviewVariants, getProductGroup, displayStarRating, getProductRating, fixElementToBottomOfPage } from 'utils';
import waja from 'waja';
import Vue from 'vue';
import abTest from 'abTest';

export default {
	store,
	props: {
		product: {
			type: Object,
			default: null,
		},
		upvotedReview: {
			type: Object,
			default: null,
		},
		heading: {
			type: String,
			default: '',
		},
		nrReviews: {
			type: Number,
			default: 0,
		},
	},
	data () {
		return {
			reviews: [], // Loaded reviews.
			hypes: [], // Loaded hypes.
			userReviewVotes: [],
			loadedVotes: false,
			totalReviewCount: 0, // Total number of reviews that the product has.
			totalHypeCount: 0, // Total number of hypes that the product has.
			ratingReviewCount: 0, // Number of reviews that determine the current rating.
			currentReviewCount: 0, // Number of reviews if the product has been released. Otherwise number of hypes.
			page: 1,
			loadedPages: {},
			// firstPageReviewCount: 3, // The number of reviews displayed on the first page. ***add back in when testing is done and has been approved***
			reviewsPerPage: 15, // The number of reviews displayed on every other page.
			isWritingReview: false,
			isWritingHype: false,
			sortingOption: 'latest',
			defaultSorting: null,
			getAllVariants,
			getReviewVariants,
			getProductGroup,
			displayStarRating,
			getProductRating,
			fixElementToBottomOfPage,
			abTest,
		};
	},
	computed: {
		firstPageReviewCount () {
			return this.abTest.shorterReviews > 0 ? 3 : 5;
		},
		productIsReleased () {
			if (! this.product.release) {
				return true; // @TODO dubbelkolla
			}
			const date = new Date();
			date.setTime(this.product.release.timestamp * 1000);
			const now = new Date();
			return now >= date;
		},
		isGroupProduct () {
			return isGroupProduct(this.product);
		},
		displayProductNames () {
			if (this.product.isFyndware) {
				return true;
			}
			return getAllVariants(this.product).length > 1;
		},
		productIsFyndware () {
			return this.product.isFyndware;
		},
		/**
		 * Products to fetch reviews for.
		 */
		productsToInclude () {
			return getReviewVariants(this.product);
		},
		/**
		 * Groups to fetch reveiws for.
		 */
		groupToInclude () {
			return getProductGroup(this.product);
		},
		hasAvgRating () {
			return this.product.averageRating !== null && this.product.averageRating !== undefined;
		},
		hasMorePages () {
			return this.computedReviews.length + this.computedHypes.length <
				this.combinedCount;
		},
		canLoadMoreReviews () {
			return (this.reviews.length + this.hypes.length < this.combinedCount);
		},
		nrReviewsLoaded () {
			return this.hypes.length + this.reviews.length;
		},
		combinedCount () {
			return this.totalReviewCount + this.totalHypeCount;
		},
		/**
		 * True if stars should be displayed, false if flames should be displayed.
		 */
		displayStars () {
			return displayStarRating(this.product);
		},
		rating () {
			return getProductRating(this.product);
		},
		userHasReviewed () {
			// @TODO denna metod returnerar inte true om användaren recensenserat produkten men recensionen inte blivit godkänd
			if (! this.isLoggedIn) {
				return false;
			}
			return this.hasReviewedProduct(this.user, this.reviews, this.product);
		},
		userHasHyped () {
			if (! this.isLoggedIn) {
				return false;
			}
			return this.hasReviewedProduct(this.user, this.hypes, this.product);
		},
		computedReviews () {
			if (this.page === 1) {
				return this.reviews.slice(0, this.firstPageReviewCount);
			} else if (this.page > 1) {
				return this.reviews.slice(0, this.reviewsPerPage * this.page);
			}
			return [];
		},
		computedHypes () {
			if (this.page === 1) {
				const slotsLeft = this.firstPageReviewCount - this.computedReviews.length;
				if (slotsLeft > 0) {
					return this.hypes.slice(0, slotsLeft);
				}
				return [];
			}

			if (this.nrReviewsLoaded - this.totalReviewCount > 0) {
				return this.hypes.slice(0, this.reviewsPerPage * this.page - this.computedReviews.length);
			}
			return [];
		},
		sortingOptions () {
			return [
				{
					label:  this.tr('LATEST'),
					value:  'latest',
				},
				{
					label:  this.tr('SCORE'),
					value:  'score',
				},
				{
					label:  this.tr('HIGHEST'),
					value:  'highest',
				},
				{
					label:  this.tr('LOWEST'),
					value:  'lowest',
				},
			];
		},
		...mapState({
			user: state => state.user,
		}),
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	watch: {
		isLoggedIn (isLoggedIn) {
			if (isLoggedIn) {
				this.getVotes();
			}
		},
		product (to) {
			this.resetPosting();
			this.resetAndGetReviews(to);
		},
		sortingOption (to) {
			this.defaultSorting = false;
			this.resetAndGetReviews(this.product, to);
		},
	},
	mounted () {
		this.defaultSorting = true;
		this.resetPosting();
		this.resetAndGetReviews(this.product);

		if (this.isLoggedIn) {
			this.getVotes();
		}
	},
	methods: {
		t,
		tr: t.prefix('REVIEW'),
		writeReview () {
			if (! this.isLoggedIn) {
				alert('Du måste vara inloggad för att kunna skriva recensioner!');
				return;
			}
			if (this.userHasReviewed) {
				alert('Du har redan recenserat den här produkten!');
				return;
			}
			if (! this.productIsReleased) {
				alert('Du kan inte recensera produkter innan de släppts!');
				return;
			}
			this.isWritingReview = true;
		},
		writeHype () {
			if (this.productIsReleased) {
				// @TODO unnecessary?
				return;
			}
			if (! this.isLoggedIn) {
				alert('Du måste vara inloggad för att kunna hypa produkten!');
				return;
			}
			if (this.userHasHyped) {
				alert('Du har redan hypat den här produkten!');
				return;
			}

			this.isWritingHype = true;
		},
		/**
		 * Check if a user has reviewed a specific product.
		 */
		hasReviewedProduct (user, reviews, product) {
			if (! reviews) {
				return false;
			}

			const res = reviews.find(review => {
				if (! review.user) {
					return false;
				}
				// If the product is a group product.
				if (product.variants) {
					return (review.user.id === user.id)
						&& (review.product.id === product.id);
				}
				return (review.user.id === user.id);
			});
			return res || false;
		},
		/**
		 * Fetches the reviews and hypes for a product.
		 */
		getReviews (product) {
			// Product groups and products (ids) to fetch reviews for.
			const group = this.groupToInclude;
			const products = this.productsToInclude;
			const page = this.page;

			waja.get('reviews')
				.data({ group, products, sortby: this.sortingOption, page })
				.on('success', res => {
					if (this.product.id !== product.id) {
						return;
					}
					if (res.data.reviews) {
						this.reviews = this.reviews.concat(res.data.reviews);
					}
					if (res.data.hypes) {
						this.hypes = this.hypes.concat(res.data.hypes);
					}

					/**
					* Checks if default sorting and if a top voted review/hype exists,
					* then adjust review/hype array so top voted is in the beginning of it
					*/
					if (this.defaultSorting && this.upvotedReview) {
						if (this.productIsReleased) {
							this.reviews = this.reviews.filter((review) => review.id != this.upvotedReview.id);
							this.reviews.unshift(this.upvotedReview);
						} else {
							this.hypes = this.hypes.filter((hype) => hype.id != this.upvotedReview.id);
							this.hypes.unshift(this.upvotedReview);
						}
					}

					this.totalReviewCount = res.data.totalReviewCount;
					this.totalHypeCount = res.data.totalHypeCount;
					this.reviewsPerPage = res.data.reviewsPerPage;
					this.ratingReviewCount = res.data.ratingReviewCount;
					this.loadedPages[page] = true;

					this.$emit('loaded', {
						nrMeterReviews: res.data.ratingReviewCount,
						nrReviews: res.data.currentReviewCount,
						reviews: this.reviews,
						status: 200,
					});
				})
				.on('error', res => {
					this.$emit('failed', {
						nrMeterReviews: 0,
						nrReviews: 0,
						reviews: [],
						status: res.status,
					});
				}).go();
		},
		getVotes () {
			// Product groups and products (ids) to fetch votes for.
			const group = this.groupToInclude;
			const products = this.productsToInclude;
			if (! this.loadedVotes && this.isLoggedIn) {
				waja.get('product/thumbs')
					.data({ group, products })
					.on('success', res => {
						this.userReviewVotes = res.data.userReviewVotes;
						this.loadedVotes = true;
					}).go();
			}
		},
		resetPosting () {
			this.isWritingReview = false;
			this.isWritingHype = false;
		},
		resetReviews () {
			this.page = 1;
			this.reviews = [];
			this.hypes = [];
			this.userReviewVotes = [];
			this.loadedPages = {};
			this.loadedVotes = false;
		},
		resetAndGetReviews (product, option) {
			this.resetReviews();
			this.getReviews(product);
		},
		setPage (newPage) {
			const oldPage = this.page;
			this.page = newPage;
			if (newPage < oldPage) {
				this.scrollPage();
			}
		},
		incrementPage () {
			if (this.hasMorePages) {
				this.page++;
				if (this.canLoadMoreReviews && ! this.loadedPages[this.page]) {
					this.getReviews(this.product);
				}
			}
		},
		decrementPage () {
			if (this.page > 1) {
				this.page--;
				this.scrollPage();
			}
		},
		scrollPage () {
			// Wait until the review and hype lists have updated.
			Vue.nextTick(() => {
				if (this.combinedCount > this.firstPageReviewCount + this.reviewsPerPage) {
					// Scroll the page so the show more/less buttons sit at the bottom of the page.
					fixElementToBottomOfPage(this.$refs.moreLessButtons);
				}
			});
		},
	},
};
</script>